import Layers from "slotworks/graphics/layers/layers";
import AutoplayModel from "slotworks/model/autoplay/autoplay-model";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import GoldenRockSpinButtonRingComponent from "../components/betbar/golden-rock-spin-button-ring-component";

export default class AutoplaySpinButtonRingControl extends AbstractControl implements Control {

    /* Freespins ring is controlled from GoldenRockBetBarComponent */
    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        if (AutoplayModel.isAutoPlaying()) {
            GoldenRockSpinButtonRingComponent.setTotalSpins(AutoplayModel.getInitialAutoplays());
            GoldenRockSpinButtonRingComponent.setTotalLeft(AutoplayModel.getAutoplays());
        }
    }
}
